/* eslint-disable @typescript-eslint/no-empty-function */
import React, { createContext, useState } from "react";
import { ContextStatus } from '@leedpulse-monorepo/enums';
import getLogs, { LogFilters } from "../../../domain/use_cases/logs/getLogs";
import { DocumentData, QueryDocumentSnapshot } from "firebase/firestore";
import { ILog } from "@leedpulse-monorepo/interfaces";

const LogsContext = createContext({
    items: [] as ILog[],
    lastVisible: {} as QueryDocumentSnapshot<DocumentData, DocumentData>,
    fetch: (filters?: LogFilters) => { },
    fetchNext: () => { },
    status: ContextStatus.IDLE,
});

export const LogsProvider: React.FC<React.PropsWithChildren> = ({
    children,
}) => {
    const [items, setItems] = useState([] as ILog[]);
    const [lastVisible, setLastVisible] = useState(
        {} as QueryDocumentSnapshot<DocumentData, DocumentData>
    );
    const [status, setStatus] = useState(ContextStatus.IDLE);
    const [currentFilters, setCurrentFilters] = useState<LogFilters | undefined>(undefined);

    const fetch = async (filters?: LogFilters) => {
        setCurrentFilters(filters);
        setStatus(ContextStatus.LOADING);
        try {
            const useCaseResponse = await getLogs(undefined, filters);
            setItems(useCaseResponse.items);
            setLastVisible(useCaseResponse.lastVisible);
            setStatus(ContextStatus.SUCCESS);
        } catch (e) {
            setStatus(ContextStatus.ERROR);
        }
    };

    const fetchNext = async () => {
        setStatus(ContextStatus.LOADING);
        try {
            const useCaseResponse = await getLogs(
                lastVisible,
                currentFilters
            );
            setItems([...items, ...useCaseResponse.items]);
            setLastVisible(useCaseResponse.lastVisible);
            setStatus(ContextStatus.SUCCESS);
        } catch (e) {
            setStatus(ContextStatus.ERROR);
        }
    };

    return (
        <LogsContext.Provider
            value={{
                items,
                lastVisible,
                fetch,
                fetchNext,
                status,
            }}
        >
            {children}
        </LogsContext.Provider>
    );
};

export default LogsContext;
